export const PLAYFAIR_2XL_MEDIUM =
    " text-xl md:text-2xl font-medium font-Playfair text-Heading_Black ";
